import React from "react";
import "./styles.scss";
import {
  useWorkShop,
  WorkshopSection,
} from "../../../../../../contexts/workshop-context/WorkshopContext";
import { Line } from "rc-progress";
import CustomMenu from "../../../../../../shared/components/CustomMenu/CustomMenu";
import { MdCheck } from "react-icons/md";
import {
  SubsectionStatus,
  useAppUser,
} from "../../../../../../contexts/user-context/UserContext";
import { zeroPad } from "../../../../../../shared/utils/Commons";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { useHistory } from "react-router-dom";
interface IProps {
  isArchived: boolean;
}
const SideBar = (props: IProps) => {
  const workshop = useWorkShop();
  const { push } = useHistory();

  return (
    <div className="student-workshop-side-bar-wrapper">
      <div className="title" style={{ maxWidth: "300px" }}>
        <div className="back-button">
          <HiArrowNarrowLeft
            onClick={() => push("/dashboard/library/workshops")}
          />
        </div>

        <div>
          <h4
            className="text-left multi-line-truncate"
            style={{
              maxWidth: "280px",
            }}
          >
            {workshop.title}
          </h4>
        </div>
        <div style={{ paddingTop: "10px" }}>
          {/* <div style={{ fontSize: "10px", fontWeight: 100 }}>
            <label>
              Start Date : {moment(workshop.startDate).format("DD/MM/YYYY")}
            </label>
          </div> */}
          <div style={{ fontSize: "12px", fontWeight: "bold" }}>
            <label>
              Points :{" "}
              {isNaN(Number(workshop.currentPoints))
                ? 0
                : workshop.currentPoints}
            </label>
          </div>
        </div>

        <div className="student-progress-bar">
          <label style={{ fontSize: "11px" }}>
            {isNaN(Number(workshop.workshopProgress))
              ? 0
              : workshop.workshopProgress}
            %
          </label>
          <div>
            <Line
              percent={workshop.workshopProgress}
              strokeWidth={3}
              trailWidth={3}
              strokeColor="#2ecc71"
              trailColor="#f2f2f2"
            />
          </div>
        </div>
      </div>

      <div className="menu">
        <CustomMenu
          data={[
            {
              text: "Summary",
              onClick: () => {
                workshop.setSelectedSubSection({
                  ...workshop.selectedSubSection,
                  orderNo: -1,
                });
              },
              isActive: workshop.selectedSubSection.orderNo === -1,
            },
          ]}
        />
        <SubsectionsMenu isArchived={props.isArchived} />
      </div>
    </div>
  );
};

const SubsectionsMenu = (props: IProps) => {
  const workshop = useWorkShop();
  return (
    <div className="subsections-menu-wrapperx">
      <ul>
        {workshop.workshopSections.map((sub, index) => (
          <SubsectionMenuItem
            isArchived={props.isArchived}
            key={index}
            title={`${zeroPad(index + 1, 2)}. ${sub.subSectionTitle}`}
            completed={sub.status === SubsectionStatus.DONE}
            workshopId={workshop.id}
            subsection={sub}
          />
        ))}
      </ul>
    </div>
  );
};

interface IPropsSMI {
  completed?: boolean;
  title: string;
  workshopId: string;
  subsection: WorkshopSection;
  isArchived: boolean;
}

const SubsectionMenuItem = (props: IPropsSMI) => {
  const workshop = useWorkShop();
  const appUser = useAppUser();
  return (
    <li
      className={
        !(
          (appUser.workshopProgress &&
            appUser.workshopProgress.filter((w) => w.workshopId === workshop.id)
              .length > 0) ||
          props.isArchived
        )
          ? ""
          : "active-m"
      }
      onClick={() => {
        if (
          (appUser.workshopProgress &&
            appUser.workshopProgress.filter((w) => w.workshopId === workshop.id)
              .length > 0) ||
          props.isArchived
        ) {
          workshop.setSelectedSubSection(props.subsection);
        }
      }}
      style={
        props.subsection.orderNo === workshop.selectedSubSection.orderNo
          ? { backgroundColor: "#006699" }
          : {}
      }
    >
      <div className="sub-title">{props.title}</div>
      <div className="sub-mark">
        {props.completed && (
          <span>
            <MdCheck />
          </span>
        )}
      </div>
    </li>
  );
};

export default SideBar;
